export enum ConfirmationStatus {
  'No Response' = 0,
  Confirmed = 1,
  Declined = 2,
}
